import { Component, OnInit } from '@angular/core';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Platform } from '@angular/cdk/platform';
import { Router } from '@angular/router';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx'; 
@Component({
  selector: 'app-customersupport',
  templateUrl: './customersupport.component.html',
  styleUrls: ['./customersupport.component.scss'],
})
export class CustomersupportComponent  {

cancel:boolean;
slotPop:boolean;
loader:boolean=false;
time = 'Time'
orderId; 
checkId;
items;
minDate = new Date();
slots; 
nullCheck: boolean = false;
orderItems: any = {};
Confpop:boolean;
postTime;
font;
length;
pay:boolean;
count;
apptDate;
dateFormat;
appTime;
list: any = [];
itemArray: any = [];
id;
show: boolean = false;
date: any; 
data;
url;
confirm:boolean;
name;
neworderId;
rebook:boolean;
numb;
bookId;
itemId;
qty;
curBooking;
constructor(private socialSharing: SocialSharing, public auth:AuthService, private router: Router, public handler: HandlerService, private platform: Platform,
 public service: ApiService, public location: LocationService,private loc: Geolocation,private geoCoder:NativeGeocoder) { }

  mobShare() {
    if (this.platform.ANDROID || this.platform.IOS) {
     var link = "hello";
      this.socialSharing.share(link + '.pdf' + ' |', null,null)
        .then(() => { return null; })
        .catch(() => { return null })
    }
  }
  ionViewWillEnter(){
    this.dateFormat = this.auth.getDateformat();
    let tpdate = new Date(Date.now());;
    let todate =new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
    let frdate = this.returnDate(tpdate);
    let trdate=this.returnDate(todate)
    let tDate = trdate + ' ' + '00:00:00';
    let fDate = frdate + ' ' + '23:59:00';
    this.font = "normal";
    this.id = localStorage.getItem('currentUserId')
    this.url = window.location.href;
    this.itemId = this.url.split('/').pop();
    this.loader = true;
    this.service.getOrderById( this.itemId).subscribe((res:any)=>{
      this.items = res;
      this.name = res.customer.firstName;
      this.numb = res.customer.contactNbrMob;
      this.length = res.requestDates.length - 1;
      Object.assign(this.items, { apptDate: res.requestDates[ this.length].apptDate, apptTime: res.requestDates[ this.length].apptTime })
      Object.assign(this.items, { name: res.items[0].name})
       this.loader = false;
      })
}

getid(id){  
  this.slotPop = true;
  this.service.getOrderById(id).subscribe((res:any)=>{
    this.orderItems=res;
    this.orderId = res.id; 
    this.length = res. requestDates.length;
    this.count = this.length - 1;
    })
  }

  cancelOrder(id) {
    this.loader = true;
    var post={}
    this.service.cancelOrder(id,post).subscribe(res => {
      this.handler.res("Booking Cancelled successfully");
      this.router.navigate(['/mybookings'])
      this.loader = false;
    },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
  }
  


returnDate(data) {
  data=new Date(data);
  let date = data.getDate();
  date = date < 10 ? '0' + date : date;
  let month = data.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let year = data.getFullYear();
  return year + '/' + month + '/' + date;
}

setTime(data, indx) {
  this.time = data.startTime;
  this.postTime = data;
  this.slots.map((res, i) => {
    indx == i ? res.style = 'active' : res.style = 'none';
  })
  setTimeout(() => {
    this.show = false;
  }, 200);
}

  UpdateService(){
    this.slotPop = false;
    this.loader = true;
       let z = this.date.getFullYear();
      let month = this.date.getMonth() + 1;
      var fmon;
      month < 10 ? fmon = '0' + month : fmon = month;
      let day = this.date.getDate();
      var fday;
      day < 10 ? fday = '0' + day : fday = day;
      let pass = z + '-' + fmon + '-' + fday;
      Object.assign(this.orderItems,{"type": 1,
      "capacityDefId":  this.postTime.capDefId,
      "apptTime": this.time,
      "apptDate": pass,
      "apptStartTime":this.time,
      "apptEndTime": this.postTime.endTime,
      "cnvcChargeApplied":true,
      "requestDates": [
        {
            "apptDate": pass,
            "apptTime":  this.time,
            "apptEndTime": this.postTime.endTime,
            "status": 1
        }]})
  this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{
    this.slotPop = false;
    this.ionViewWillEnter();
    this.handler.res('Rescheduled Successfully !!')   
    localStorage.setItem('orderId', this.orderId);
     this.loader = false;
  },err => {
    this.loader = false;
    this.handler.err(err)
  })
  }

  getSlots(id) {
    this.show = true;
    let x = this.date.getDate();
    let y = this.date.getMonth() + 1;
    let z = this.date.getFullYear();
    let pass = x + '-' + y + '-' + z;
    let post = {
      "targetCenterId":  this.checkId,
      "targetSource":  this.checkId,
      "schElements": [1],
      "requestDate": pass,
      "status": ["SlotsAvailable"],
      "independentEntities": true,
      "slotDuration": 30
    }
    this.service.getTimeSlots(pass, post).subscribe((res: any) => {
      if (res == null) {
        this.nullCheck = true;
      }
      else {
        this.nullCheck = false;
        this.slots = res;
        this.slots.map(sum => Object.assign(sum, { style: 'none' }));
      }
  
    },
      err => {
           this.handler.err(err)
      })
  
  }

  clearTime() {
    this.time = 'Time';
    this.slots = [];
    this.show = false;
  }
  onInput() {
    this.location.autoComplete();
  }

  rebookService() {
    var x =[]
    this.items.items.map(dat=>{
      x.push({id:dat.id,qty:dat.qty})
    })
     let postData = {
      customerId: localStorage.getItem('currentUserId'),
      delDoorNbr: this.location.houseNbr,
      delStreet: this.location.street,
      delCity: this.location.cityId,
      delState: this.location.stateId,
      status: 1,
      paymtStatus: 1,
      paymtMode: 1,
      orgId: localStorage.getItem('organizationId'),
      orderType: 2,
      items:x
    }
    this.service.placeOrder(postData).subscribe((res: any) => {
      this.neworderId = res.id;
      this.service.getOrderById(this.neworderId).subscribe((res: any) => {
        this.orderItems = res;
        let z = this.date.getFullYear();
        let month = this.date.getMonth() + 1;
        var fmon;
        month < 10 ? fmon = '0' + month : fmon = month;
        let day = this.date.getDate();
        var fday;
        day < 10 ? fday = '0' + day : fday = day;
        let pass = z + '-' + fmon + '-' + fday;
        Object.assign(this.orderItems,{"type": 1,
        "capacityDefId":  this.postTime.capDefId,
        "apptTime": this.time,
        "apptDate": pass,
        "apptStartTime":this.time,
        "apptEndTime": this.postTime.endTime,
        "cnvcChargeApplied":true,
        "requestDates": [
          {
              "apptDate": pass,
              "apptTime":  this.time,
              "apptEndTime": this.postTime.endTime,
              "status": 1
          }]})
    this.service.updateOrder(this.neworderId,this.orderItems).subscribe((res:any) =>{
      this.rebook = false;
      this.router.navigate(['declaration/'+this.neworderId])
      localStorage.setItem('orderId',this.neworderId)
      this.handler.res('Rebooked Successfully !!')   
     },err => {
      this.handler.err(err)
    })
      })
    },
      err => {
        this.handler.err(err);
  
         })
  }


  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.setLoc();  
    this.location.pop = false;
  }
  
  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             this.location.cityId=loc[0].locality;    
             this.location.regionId=loc[0].subLocality;       
        })        
    })
 }   
}

}


  


